import Vue from "vue";

let aiwriterVueFile = require("./aiWriter.vue");
let aiwriterVue = aiwriterVueFile.default;
import aiwriterVue2 from "./aiWriter.vue";

// const DownloadInstance = Vue.extend(require("./aiWriter.vue").default);
const DownloadInstance = Vue.extend(aiwriterVue2);
let instance = null;
let confirmPromise = null;
let confirmResolve = null;
let canUse = true;

let getInstance = () => {
  return new DownloadInstance({
    el: document.createElement("div"),
  });
};

let close = () => {
  if (instance) {
    instance.close();
    instance.$el.parentNode.removeChild(instance.$el);
    instance = null;
    if (confirmResolve) {
      confirmResolve(false);
      confirmResolve = null;
    }
    confirmPromise = null;
  }
};

let AiWriter = (config) => {
  if (instance) {
    // close()
    if (config) {
      close();
      canUse = false;
    } else {
      canUse = false;
    }
  } else {
    if (config) {
      canUse = false;
    } else {
      canUse = true;
    }
  }

  if (canUse) {
    instance = getInstance();
    console.log("aiwriter instance", instance);
    document.body.appendChild(instance.$el);
    confirmPromise = new Promise((resolve, reject) => {
      confirmResolve = resolve;
    });
    instance.open(config, confirmResolve);
  }

  // return confirmPromise;
  return instance;
};

export default AiWriter;
